/**
 * @generated SignedSource<<fda1a3e0d2e85f667e2edf111afd83e4>>
 * @relayHash e42e4dd054a2dadff7b10b8b3f62c00e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19531590355e60790126ac534deaf5b99f3df3532b9e58e93d9bc40cf322ab64

import type { ConcreteRequest } from 'relay-runtime';
export type TeamTypeDefaultFor = "ADMIN" | "USER_MANAGED" | "VERIFIED" | "%future added value";
export type TeamTypeSelectQuery$variables = {
  scopeId: string;
};
export type TeamTypeSelectQuery$data = {
  readonly team: {
    readonly typesWithinScope: {
      readonly nodes: ReadonlyArray<{
        readonly default: TeamTypeDefaultFor | null | undefined;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly verified: boolean | null | undefined;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type TeamTypeSelectQuery = {
  response: TeamTypeSelectQuery$data;
  variables: TeamTypeSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeId"
  }
],
v1 = [
  {
    "concreteType": "TeamQuery",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "scopeId",
            "variableName": "scopeId"
          }
        ],
        "concreteType": "TeamTypeConnection",
        "kind": "LinkedField",
        "name": "typesWithinScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "TeamType",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "verified"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "default"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TeamTypeSelectQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamTypeSelectQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "19531590355e60790126ac534deaf5b99f3df3532b9e58e93d9bc40cf322ab64",
    "metadata": {},
    "name": "TeamTypeSelectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "00cbedec6c8ea92e377a6a929a99eb1c";

export default node;
